module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_yushou-95077a3828f7fe8cb0754ef3817651a7.png";